import { Box, Flex, Heading, Icon } from '@chakra-ui/react';
import { FaRegCopy } from 'react-icons/fa';
import { IoWarning } from 'react-icons/io5';
import FaceliftIconButton from '@/components/Atoms/FaceliftIconButton';
import FaceliftInput from '@/components/Atoms/FaceliftInput';
import FaceliftText from '@/components/Atoms/FaceliftText';
import { colors } from '@/components/ui/theme';

export interface PaymentLinkBoxProps {
  /** The Stripe session payment URL */
  link: string;
  onCopyLink?: () => void;
}

const PaymentLinkBox: React.FC<PaymentLinkBoxProps> = ({
	link,
	onCopyLink,
}) => {
  return (
    <Box borderRadius="lg">
      <Flex align="center" mb={6} gap={3}>
        <Icon as={FaRegCopy} boxSize={6} />
        <Heading size="lg" fontWeight="medium">
          Stripe Payment Link
        </Heading>
      </Flex>

      <Box mb={6} position="relative">
        <FaceliftInput
          value={link}
          readOnly
          border="none"
          fontSize="md"
          _focus={{ outline: 'none', boxShadow: 'none' }}
        />
        <Box position="absolute" right={0} top={0} h="full">
          <FaceliftIconButton
            aria-label="Copy URL"
            h="full"
            borderLeftRadius={0}
            borderRightRadius="md"
            bg="transparent"
            color="inherit"
            borderRadius="full"
            _hover={{
              bg: colors.hoverBg,
              transition: 'opacity 0.2s ease-in-out',
            }}
            css={{
              '& svg': {
                width: '20px !important',
                height: '22px !important',
              },
            }}
            onClick={() => {
              onCopyLink?.();
              navigator.clipboard.writeText(link);
            }}
          >
            <FaRegCopy />
          </FaceliftIconButton>
        </Box>
      </Box>

      <Box
        boxShadow="sm"
        border="1px solid"
        borderColor="orange.300"
        bg="orange.50"
        _dark={{
          borderColor: 'orange.600',
          bg: 'orange.900',
        }}
        p={4}
        borderRadius="md"
      >
        <Flex align="center" gap={2} mb={4}>
          <Icon as={IoWarning} boxSize={5} color="orange.500" />
          <FaceliftText
            fontSize="lg"
            fontWeight="semibold"
            fontStyle="italic"
            color="orange.700"
            _dark={{ color: 'orange.300' }}
          >
            Important Notes:
          </FaceliftText>
        </Flex>
        <Box as="ul" pl={6} css={{ listStyleType: 'disc' }}>
          <Box as="li" fontSize="md" lineHeight="tall" mb={3}>
            Please confirm with the client that these are the invoices they'd
            like to pay, as they will be locked for 30 days to prevent duplicate
            payments once directed to Stripe.
          </Box>
          <Box as="li" fontSize="md" lineHeight="tall">
            Please inform the client that this payment session on Stripe will
            expire after 30 days. Once expired, you'll need to refill your
            Shopping Cart with the desired invoices and generate a new Payment
            Link.
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentLinkBox;
